import { HttpUtils } from './http.utils'
import { environment } from '../../environment'

export class BlogApi {
  /**
   * 获取当前用户级别
   */
  static getUserlevel(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/userlevel/get`, {params: params})
  }

  /**
   * 获取文章
   */
  static getContent(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/get`, {params: params})
  }

  /**
   * 保存文章
   */
  static saveContent(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/post/put`, params)
  }

  /**
   * 强制保存文章
   */
  static forceSaveContent(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/post/put?force=true`, params)
  }

  /**
   * 话题搜索
   */
   static searchTags(params) {
    // return HttpUtils.get(`https://entities.caixin.com/apientry/cms-tag/search?keyword=${params}`)
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/tag/search?keyword=${params}`)
  }

  /**
   * 分类搜索
   * keyword
   */
   static searchCategorys(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/usercate/search`, {params: params})
  }

  /**
   * 添加分类
   */
   static addCategorys(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/usercate/add`, {params: params})
  }

  /**
   * 上传文件
   */
  static uploadFile(params) {
    return HttpUtils.uploadFile(`${environment.apiBlogEditorUrl}/blog/file/upload`, params)
  }

  /**
   * 作者搜索
   */
  static searchAuthor(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/user/search`, {params: params})
  }

  /**
   * 查询文章指定meta信息
   */
  static getMetaInfo(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/meta/get`, {params: params})
  }
  
  /**
   * 重新生成语音
   */
  static generateVoice(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/tts`, {params: params})
  }


  /**
   * 文章列表
   */
  static getArticleList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/list`, {params: params})
  }

  /**
   * 文章es索引搜索列表
   */
  static getIndexArticleList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/index/list`, {params: params})
  }

  /**
   * 文章快速编辑
   */
  static quickSaveInfo(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/quickedit`, {params: params})
  }

  /**
   * 删除
   */
  static sendTrashRequest(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/post/trash`, {params: params})
  }

  /**
   * 话题列表
   */
  static getTagList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/tag/list`, {params: params})
  }

  /**
   * 保存话题
   */
  static saveTag(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/tag/save`, params)
  }
  
  /**
   * 删除话题
   */
  static deleteTagList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/tag/remove`, {params: params})
  }
  
  /**
   * 个人分类列表
   */
  static getClassificationList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/uc/list`, {params: params})
  }

  /**
   * 保存个人分类
   */
  static saveClassification(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/uc/save`, params)
  }

  /**
   * 删除个人分类
   */
  static deleteClassification(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/uc/remove`, {params: params})
  }

  /**
   * 博主置有效/无效
   */
  static setUserStatus(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/user/status`, {params: params})
  }

  /**
   * 获取博主详情
   */
  static getUserDetail(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/user/detail`, {params: params})
  }

  /**
   * 从个人中心获取用户信息
   */
  static getUserInfo(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/user/usercenter`, {params: params})
  }

  /**
   * 判断博客个人页 是否重复
   */
  static getUrlIsUse(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/user/existUrl`, {params: params})
  }

  /**
   * 保存博主
   */
  static saveUser(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/user/save`, params, {}, false)
  }

  /**
   * 敏感词列表
   */
  static getSensitiveWordsList(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/sword/list`, {params: params})
  }

  /**
   * 保存敏感词
   */
  static saveSensitiveWord(params) {
    return HttpUtils.post(`${environment.apiBlogEditorUrl}/blog/sword/save`, params)
  }

  /**
   * 删除敏感词
   */
  static deleteSensitiveWord(params) {
    return HttpUtils.get(`${environment.apiBlogEditorUrl}/blog/sword/remove`, {params: params})
  }

}